/**
 * 利用履歴関連のAPIエンドポイント
 */

import apiClient from '../client';
import type { Usage, UsageCreate } from '../../../types';

export const usageApi = {
  /**
   * 利用履歴取得
   * @param customerId - 顧客ID（オプション）
   * @param storeId - 店舗ID（オプション）
   */
  getUsages: async (customerId?: number, storeId?: number): Promise<Usage[]> => {
    const params = new URLSearchParams();

    if (customerId !== undefined) {
      params.append('customer_id', customerId.toString());
    }
    if (storeId !== undefined) {
      params.append('store_id', storeId.toString());
    }

    const queryString = params.toString();
    return apiClient.get<Usage[]>(`/usages${queryString ? `?${queryString}` : ''}`);
  },

  /**
   * 利用登録
   */
  createUsage: async (usageData: UsageCreate): Promise<Usage> => {
    return apiClient.post<Usage>('/usages', usageData);
  }
};
